import { render, staticRenderFns } from "./PopUpEditar.vue?vue&type=template&id=1f99cb80"
import script from "./PopUpEditar.vue?vue&type=script&lang=js"
export * from "./PopUpEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports